import { render, staticRenderFns } from "./AudraStatusList.vue?vue&type=template&id=8e23ebb2&"
import script from "./AudraStatusList.vue?vue&type=script&lang=js&"
export * from "./AudraStatusList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports